module.exports = __webpack_public_path__ + "static/typewriter3-cb67451705f227ca3d1ce98d7f97c856.png";